/** Agent debug logging (Cursor debug sessions only). */
export function uiDebugLog(location, message, data = {}, hypothesisId = '') {
  // #region agent log
  fetch('http://127.0.0.1:7317/ingest/33d7d7b2-b1b0-4d0c-a3a9-ece961ebff3d', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '6b525d' },
    body: JSON.stringify({
      sessionId: '6b525d',
      runId: 'ui-e2e',
      hypothesisId,
      location,
      message,
      data,
      timestamp: Date.now(),
    }),
  }).catch(() => {});
  // #endregion
}

export function apiErrorDetail(data, fallback = 'Request failed') {
  const detail = data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') {
    return detail.message || detail.msg || fallback;
  }
  return data?.message || fallback;
}
